import { BaseModel } from '@nuxtDatakodeUtils/models/BaseModel'
import type { Application } from './Application'

type GenericTableData = PildomModules.Generic.Data.GenericTableData
type GenericApplicationData = PildomModules.Generic.Data.GenericApplicationData

export class ApplicationTable extends BaseModel<GenericTableData> {
    override endPoint: string = 'generic/{application_slug}/tables'
    override permissionName: string = 'APP_{application_name}_application'
    override translationKey: string = 'generic'

    application: Application

    setApplication(application: Application) {
        this.application = application
    }

    override getEndPoint(useEntityId: boolean = false): string {
        return super.getEndPoint(useEntityId).replace('{application_slug}', (this.application.data as GenericApplicationData).slug)
    }
}
